<template>
  <div class="process-main-wrap">
    <div
      class="items-center p-2 mb-2 bg-gray-100 border border-gray-200 shadow shadow-md is-flex rounded-t-md"
      :class="[
        useProcessStore().process.origin_type && !useProcessStore().process.destination_type ? 'rounded-br-md' : '',
        !useProcessStore().process.origin_type && useProcessStore().process.destination_type ? 'rounded-bl-md' : '',
      ]"
    >
      <span>
        <span class="font-mono">
          <a class="ml-3" :href="'/process/' + useProcessStore().process?.guid + '/list'">
            {{ useProcessStore().process.name }}
          </a>
          <span class="font-extrabold"> • {{ useProcessStore().current_step?.name }} </span>
        </span>
        <span v-if="useProcessStore().process?.document_data" class="px-2 py-1 ml-4 font-bold text-green-800 bg-green-200 rounded-full">
          {{ useProcessStore().process?.document_data?.process_number }}
        </span>
        <i class="ml-4 mr-2 text-gray-400 fa fa-user fa-xs"></i>
        <span class="text-sm text-gray-400">{{ useProcessStore().process?.document_data?.created_by_name }}</span>
        <i class="ml-2 mr-2 text-gray-400 fa fa-calendar fa-xs"></i>
        <span class="text-sm text-gray-400">{{ helpers.dateFormatter(useProcessStore().process?.document_data?.created_at) }}</span>
        <span class="ml-2 text-sm text-gray-400" v-if="useProcessStore().process.diary_id">
          <a :href="`/diary/get/` + useProcessStore().process.diary_id" class="diary-link">
            <i class="fa fa-book" aria-hidden="true"></i>
            Shko ne ditar
          </a>
        </span>
      </span>
      <span v-if="useProcessStore().process?.document_data?.completed == 1" class="ml-auto bg-green-500 border border-green-600 rounded-full">
        <i class="m-2 text-white fa fa-check"></i>
      </span>
      <span v-else class="ml-auto font-mono font-extrabold text-gray-400 is-flex"> {{ useProcessStore().current_step_index + 1 }} ∷ {{ useProcessStore().process_steps.length }} </span>
    </div>

    <div class="flex-row mb-2 is-flex is-justify-content-space-between sm:flex-column md:flex-row">
      <div v-if="useProcessStore().process.origin_type">
        <party-component v-if="useProcessStore().process.origin_type" :party="useProcessStore().process.origin_type" :type="'origin'"></party-component>
      </div>
      <!-- <div class="text-red-500 is-align-self-center" v-else>E PAPERCAKTUAR</div> -->
      <div class="w-1/2 ml-auto border-slate-100">
        <party-component v-if="useProcessStore().process.destination_type" :party="useProcessStore().process.destination_type" :type="'destination'"></party-component>
      </div>
    </div>

    <!--search  -->
    <search-index></search-index>
    <div style="flex-grow: 1">
      <div class="single-step-wrap">
        <!-- Product list -->
        <div style="flex-grow: 1" class="is-flex is-flex-direction-column">
          <div class="">
            <product-list></product-list>
          </div>
          <div class="is-flex">
            <div>
              <!-- <strong class="mt-3 ml-3 is-flex-grow-1">
                Total
              </strong> -->
            </div>
            <!-- BLOCK: totals document -->
            <div class="w-2/5 ml-auto">
              <div v-if="useProcessStore().product_list.length > 0 && useProcessStore().current_step.can_see_price" class="">
                <document-total></document-total>
              </div>
            </div>
          </div>
        </div>
        <!-- BLOCK: step disputes -->
        <step-disputes v-if="useProcessStore().process?.document_data?.completed != 1"></step-disputes>
        <span
          v-else
          class="w-full px-4 py-1 font-bold text-center border-t"
          :class="[
            useProcessStore().process?.document_data?.with_rejection
              ? 'border-red-700 bg-red-50 text-red-700'
              : hasIncompleteTransportService
              ? 'border-amber-200 bg-amber-200'
              : 'border-emerald-700 bg-green-50 text-emerald-700',
          ]"
        >
          <div class="flex items-center justify-center">
            <div
              class="mr-5 border rounded-full"
              :class="[useProcessStore().process?.document_data?.with_rejection ? 'border-red-400 bg-red-500' : hasIncompleteTransportService ? 'border-yellow-400 bg-yellow-500' : 'border-green-400 bg-green-500']"
            >
              <i v-if="useProcessStore().process?.document_data?.with_rejection" class="m-2 text-white fa fa-xmark fa-2x"></i>
              <i v-else-if="hasIncompleteTransportService" class="m-2 text-white fa fa-triangle-exclamation fa-2x"></i>
              <i v-else class="m-2 text-white fa fa-check fa-2x"></i>
            </div>
            <div class="flex flex-col">
              <span v-if="useProcessStore().process?.document_data?.with_rejection"> DOKUMENTI ESHTE I REFUZUAR </span>
              <span v-else-if="hasIncompleteTransportService">
                DOKUMENTI ËSHTË PROCESUAR, POR KA TRANSPORTE TË PAPËRFUNDUARA.
                <div class="text-sm" v-if="itemsWithIncompleteTransport.length > 0">
                  <div>Produkte me transport në pritje</div>
                  <ul>
                    <li v-for="item in itemsWithIncompleteTransport" :key="item.guid">{{ item.name }}</li>
                  </ul>
                </div>
              </span>
              <span v-else> DOKUMENTI ESHTE I PERFUNDUAR </span>
              <div class="text-xs font-light text-black">
                <i class="text-gray-400 fa fa-user fa-xs"></i>
                {{ useProcessStore().process?.document_data?.completed_by_name }}
                <i class="ml-3 text-gray-400 fa fa-calendar fa-xs"></i>
                {{ helpers.dateFormatter(useProcessStore().process?.document_data?.completed_at) }}
              </div>
              <div v-if="useProcessStore().process?.document_data?.with_rejection" class="font-normal text-14px">Refuzuar: {{ useProcessStore().process?.document_data?.rejection_name }}</div>
              <div v-if="useProcessStore().process?.document_data?.with_text" class="font-normal text-14px">Shenime per refuzimin: {{ useProcessStore().process?.document_data?.with_text }}</div>
            </div>
          </div>
        </span>
      </div>
    </div>
  </div>
</template>

<script setup>
import { watch, computed } from "vue";
import { useRoute } from "vue-router";
import { useProcessStore } from "@/stores/process";
import { getCurrentInstance, onBeforeMount } from "vue";
import partyComponent from "./components/party-component";
import documentTotal from "./components/document-total";

import searchIndex from "@/pages/process/components/search/index.vue";
import stepDisputes from "@/pages/process/components/step_disputes.vue";
import productList from "@/pages/process/components/product_list/index.vue";
import helpers from "@/helpers.js";
// Get first step

onBeforeMount(() => {
  // BLOCK: add page title on page open
  getCurrentInstance().appContext.config.globalProperties.$document.title =
    useProcessStore().process?.name?.toUpperCase() +
    " • " +
    useProcessStore().current_step?.name?.toUpperCase() +
    (useProcessStore().process?.document_data?.id ? " #" + useProcessStore().process?.document_data?.id : " - DOKUMENT I RI");
});

const route = useRoute();

// watch for route changes to the process_id
watch(
  () => route.params.process_id,
  (process_id) => {
    // BLOCK: get process data
    useProcessStore().get_process_steps(process_id, 0);
  }
);

const hasIncompleteTransportService = computed(() => {
  const items = useProcessStore().process?.document_data?.items;

  if (!items || !Array.isArray(items) || items.length === 0) {
    return false;
  }

  // Check if any item has an incomplete transport service
  return items.some((item) => {
    // Check if item has extra_services
    if (!item.extra_services || !Array.isArray(item.extra_services) || item.extra_services.length === 0) {
      return false;
    }

    // Check if any service is a transport service and is not completed
    return item.extra_services.some((service) => service.service_type_name === "Transport" && service.completed_status === 0);
  });
});

const itemsWithIncompleteTransport = computed(() => {
  const items = useProcessStore().process?.document_data?.items;

  if (!items || !Array.isArray(items) || items.length === 0) {
    return [];
  }

  // Filter items that have incomplete transport services
  return items
    .filter((item) => {
      // Check if item has extra_services
      if (!item.extra_services || !Array.isArray(item.extra_services) || item.extra_services.length === 0) {
        return false;
      }

      // Check if any service is a transport service and is not completed
      return item.extra_services.some((service) => service.service_type_name === "Transport" && service.completed_status === 0);
    })
    .map((item) => ({
      name: item.name,
      id: item.id,
      guid: item.guid,
    }));
});
</script>

<style scoped>
.single-step-wrap {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.process-main-wrap {
  height: 100%;
  display: flex;
  flex-direction: column;
}
</style>
